

<div class="mobile-hero-banner-image-container">
	<img [src]="siteImage"
		[alt]="siteDetails ? siteDetails.SiteName : 'Beachsite'">
</div>

<div class="nsw-hero-banner nsw-hero-banner--dark">	
	<div class="nsw-hero-banner__container">
		<div class="nsw-hero-banner__wrapper">			
			<div class="nsw-hero-banner__content">
				<h1>{{siteDetails ? siteDetails.SiteName : ""}}</h1>
				<div class="banner-button-favourites-wrapper">
					<div class="nsw-hero-banner__button">
						<a class="nsw-button nsw-button--white" [routerLink]="['/home']"
							[queryParams]="{ siteIdentifier : siteDetails?.Identifier ?? '' }">View on map</a>
					</div>
					<app-favourite-icon [showLabel]="true" class="add-to-favourites"
						[siteName]="siteDetails?.SiteName"
						[siteIdentifier]="siteDetails?.Identifier ?? ''">
					</app-favourite-icon>
				</div>
			</div>
			<div class="nsw-hero-banner__box">
				<img class="nsw-hero-banner__image siteImage" [src]="siteImage"
					[alt]="siteDetails ? siteDetails.SiteName : 'Beachsite'">
			</div>
		</div>		
	</div>
</div>

